import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { HashRouter, Router, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import "./setupTalGel";
import PolicyRecord from "./pages/PolicyRecord";
import CertificateOfCurrency from "./pages/CertificateOfCurrency";
import PolicySummary from "./pages/PolicySummary";

const history = createBrowserHistory();
let RouterComponent = Router;
const mmcFlagInput = document.getElementById("mmc-coc");

if (mmcFlagInput && mmcFlagInput.value === "true") {
  RouterComponent = HashRouter;
}

ReactDOM.render(
  <React.StrictMode>
    <RouterComponent history={history}>
      <Route path="/dashboard/policy-details" component={PolicyRecord} />
      <Route
        path="/dashboard/CertificateOfCurrency"
        component={CertificateOfCurrency}
      />
      <Route path="/dashboard/PolicySummary" component={PolicySummary} />
    </RouterComponent>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
